module.exports = __webpack_public_path__ + "webassets/cookies-plate.215f2687.png";